/*
 * File Created: Thursday, 11th May 2023 9:23:22 pm
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2023 Addble Solutions Private Limited. All Rights Reserved.
 */

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { type Theme, useTheme, IconButton } from "@mui/material";
import React from "react";
import { Colors } from "../../constants/color";
import type { CartItem as CartItemProps } from "../../types/cartItem/cartItem.type";
import { AiOutlineClose } from "react-icons/ai";
import { IoAdd, IoRemove  } from "react-icons/io5";
import { CartContext } from "../../context/cartContext.context";

function CartItem(props: CartItemProps) {
  const theme: Theme = useTheme();
  const { removeItemFromCart, decreaseQty, increaseQty,  }  = React.useContext(CartContext);
  const totalAmount = props.qty !== undefined ? parseFloat(props.mrp.toString()) * parseFloat(props.qty) : parseFloat(props.mrp.toString()) * 1;
  const roundedValue = Math.round(totalAmount * 100 + Number.EPSILON) / 100;

  // console.log("CART ITEM : SPLIT : ", props.mrp.split("₹"));

  return (
    <Box
      sx={{
        width: {
          xs: "100%",
        },
        display: "flex",
        flexDirection: { xs: "column", md: "row-reverse" },
        alignItems: { xs: "center" },
        justifyContent: { xs: "center", md: "space-between" },
        padding: {xs: theme.spacing(), md: theme.spacing(3, 0)},
        borderTop: { xs: `1px solid ${Colors.concrete}` },
        borderRight: { xs: `1px solid ${Colors.concrete}`, md: "none" },
        borderBottom: { xs: `1px solid ${Colors.concrete}` },
        borderLeft: { xs: `1px solid ${Colors.concrete}`, md: "none" },
        "&:not(:last-child)": {
          borderBottom: {xs: `1px solid ${Colors.concrete}`, md: "none"},
        }
      }}
    >
      <Box
        sx={{
          width: {xs: "100%", md: "auto"},
          display: "flex",
          justifyContent: {xs: "end", md: "center"},
        }}
      >
        <IconButton
          size="small"
          onClick={() => removeItemFromCart(props.id)}
        >
          <AiOutlineClose style={{ color: Colors.dusty_gray }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          width: {xs: "100%", md: "calc(100% - 28px)"},
          display: "flex",
          flexDirection: {xs: "column", md: "row"},
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: 'center',
            gap: 2,
            // backgroundColor: "green",
          }}
        >
          <Box
            component="img"
            alt={props.images[0].type}
            src={props.images[0].src}
            sx={{
              width: {xs: "120px", md: "80px"},
              height: {xs: "120px", md: "80px"},
              backgroundColor: Colors.white,
            }}
          />
          <Box
            sx={{
            }}
          >
            <Typography variant="h6" fontWeight="500">
              {props.name}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            width: { xs: "100%", md: "54%" },
            // backgroundColor: "indigo",
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            gap: { xs: 1, md: 0 },
            "& .cart_detail": {
              width: "40%",
              display: "flex",
              justifyContent: { xs: "center", md: "initial" },
            }
          }}
        >
          <Box
            sx={{ 
              width: "30%",
              display: "flex",
              justifyContent: { xs: "center", md: "initial" },
              marginTop: theme.spacing(),
            }}
            >
            <Typography variant="h6" fontWeight="500">
              ₹{props.mrp}
            </Typography>
          </Box>
          <Box className="cart_detail">
            <Box
              sx={{
                width: "fit-content",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                border: `1px solid ${Colors.dusty_gray}`,
                paddingBlock: theme.spacing(0.5),
                gap: 2.5,
              }}
            >
              <IconButton
                size="small"
                onClick={() => decreaseQty(props.id)}
                disabled={props.qty === "1"}
              >
                <IoRemove />
              </IconButton>
              <Typography variant="h6">{props.qty}</Typography>
              <IconButton
                size="small"
                onClick={() => increaseQty(props.id)}
              >
                <IoAdd />
              </IconButton>
            </Box>
          </Box>
          <Box
            sx={{ 
              width: "30%",
              display: "flex",
              justifyContent: { xs: "center", md: "initial" },
              marginBottom: theme.spacing(),
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 500,
                color: Colors.fallow,
              }}
            >
              ₹{roundedValue}
            </Typography>
          </Box>
        </Box>
      </Box>
      {/* <Box
        sx={{
          width: {xs: "100%", md: "auto" },
          display: "flex",
          justifyContent: "end",
          // backgroundColor: "green",
        }}
      >
        <IconButton size="small" onClick={() => removeItemFromCart(props.id)}>
          <AiOutlineClose style={{ color: Colors.dusty_gray }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          flexDirection: {xs: "column", md: "row"},
          alignItems: "center",
          gap: {xs: "auto", md: 1},
        }}
      >
      <Box
        component="img"
        alt={props.images[0].type}
        src={props.images[0].src}
        sx={{
          width: {xs: "120px", md: "80px"},
          height: {xs: "120px", md: "80px"},
          backgroundColor: Colors.white,
        }}
      />
      <Box
        sx={{
          // width: "calc(100% - 120px)",
          // backgroundColor: "greenyellow",
          width: "100%",
          display: "flex",
          flexGrow: 1,
          // flexDirection: "column",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "center" },
          justifyContent: { xs: "center", md: "space-between" },
          gap: 1.5,
          paddingBlock: theme.spacing(1.5),
          // backgroundColor: "green",
        }}
      >
        <Typography variant="h6" fontWeight="500">
          {props.name}
        </Typography>
        <Box
          sx={{
            width: "49%",
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "center" },
            justifyContent: {xs: "space-between", md: "initial"},
            // gap: {xs: 2, lg: 4 },
            backgroundColor: "indigo",
          }}
        >
          <Typography
            className="cart-mrp"
            variant="h6"
            sx={{
              width: "34%"
            }}
          >
            {props.mrp}
          </Typography>
          <Box
            sx={{
              width: "34%"
            }}
          >
            <Box
              sx={{
                width: "104px",
                display: "flex",
                flexDirection: "row",
                border: `1px solid ${Colors.dusty_gray}`,
                paddingBlock: theme.spacing(0.5),
                gap: 2.5,
                // flexGrow: 1,
              }}
            >
              <IconButton
                size="small"
                onClick={() => decreaseQty(props.id)} disabled={props.qty === "1"}
              >
                <IoRemove />
              </IconButton>
              <Typography variant="h6">{props.qty}</Typography>
              <IconButton size="small" onClick={() => increaseQyt(props.id)}>
                <IoAdd />
              </IconButton>
            </Box>
          </Box>
          <Typography
            variant="h6"
            sx={{
              width: "34%",
              // backgroundColor: "green",
              color: Colors.fallow 
            }}
          >
            ₹{totalAmount}
          </Typography>
        </Box>
      </Box>
      </Box> */}
    </Box>
  );
}

export default CartItem;
